import {AccountInventoryField} from './account-inventory-field';

export class InventoryMappingRequestModel {
  accountId: number;
  inventoryMappingFields: AccountInventoryField[];
  deletedInventoryMappingFields: number[];

  constructor()
  {
    this.accountId = null;
    this.inventoryMappingFields = [];
    this.deletedInventoryMappingFields = [];
  }
}
